import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    render () {
        const { query, result, showResult, showFullForm, onSearch, onBlur, onKeyDown, toggleShowFullForm, selectedItem, searchUrl } = this.props;
        return (
            <div className="quick-search" role="search">
                <div className={`quick-search__form ${showFullForm ? 'quick-search__form--force-show' : ''}`} role="search">
                    <input className="quick-search__input" type="search" name="search" placeholder={translate('general.searchproducts')}
                        autoComplete="off" value={query} onChange={event => onSearch(event.target.value)}
                        onKeyDown={event => onKeyDown(event, {searchUrl})} ref={(input) => { this.searchInput = input; }}
                        onBlur={() => onBlur() }/>
                    {showResult && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl}/>}
                </div>
            </div>
        )
    }
}

export default QuickSearch;
